import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { DonleeFechtAPI } from '../../api/Donlee';
import ErrorAlert from '../Alerts/ErrorAlert';
import { RenderIf } from '../utils/RenderIf';

import Accordion from 'react-bootstrap/Accordion';

function ModuleLocator({ locator, setLocator }) {
    const [showModal, setShowModal] = useState(false)
    let token = localStorage.getItem('x-access-machine-token');
    const [tempClient_Phone, setTempClient_Phone] = useState("");
    const [handler, setHandler] = useState(0)


    //Hook to load the initial info
    useEffect(() => {
        setHandler(0)
    }, [handler]);


    return (
        <>


            <div class="card">
                <div className='d-flex justify-content-between align-items-center'>
                    <h4 className="text-primary small">Localizador</h4>
                    <h5> <span class="badge text-bg-primary">{locator}</span></h5>
                </div>
                <div class="card-body">
                    <input type="text" className="form-control border" placeholder={'Número de localizador '} onChange={(e) => (setLocator(e.target.value))} />
                </div>
            </div>

            {/* <div className='p-2'>

                Localizador:{locator}
                <div className='d-flex justify-content-center'>
                    <div>
                        <span className='text-primary fw-bold'>Ingrese número de localizador</span>
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-md-6 mt-2'>
                        <div className='row'>
                            <div className='col-sm-12'>

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default ModuleLocator